import React                  from "react";
import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';

import { setTenant } from '../../store/actions/tenant';

const allTenants = ["uk", "au", "es", "ie", "it", "nz"];

export class TenantProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tenants: this.props.tenants
        };
    }

    static defaultProps = {
        tenants: allTenants,
        defaultTenant: allTenants[0],
        detect: true
    };

    componentDidMount() {
         this.props.setTenant(this.props.detect ? this.computeTenant() : this.props.defaultTenant);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultTenant !== this.props.defaultTenant) {
            const state = {
                selected: this.props.detect ? this.computeTenant() : this.props.defaultTenant
            };

            this.props.setTenant(state.selected);
        }

        return null;
    }

    computeTenant() {
        const host = window.location.hostname;
        let { tenants, defaultTenant } = this.props;

        let tenant = tenants.find(t => this.hostIsOkForTenant(host, t)) || defaultTenant;

        return tenant;
    }

    hostIsOkForTenant(host, tenant) {
        host = host.toLowerCase();
        tenant = tenant.toLowerCase();

        return host.endsWith(tenant) || host.startsWith(`${tenant}-`);
    }

    render() {
        const { tenant } = this.props;
        console.error('NO? ', tenant);
        return tenant ? this.props.children: null;
    }
}


export default connect(
    // State
    state => ({
        tenant: state.tenant.currentTenant
    }),

    // Actions
    dispatch => bindActionCreators({
        setTenant: setTenant
    }, dispatch)
)(TenantProvider);



// WEBPACK FOOTER //
// /src/components/framework/TenantProvider.js